import { createFileRoute, redirect } from '@tanstack/react-router';
import { SubscribeCompletePage } from '@/components/billing';

export const Route = createFileRoute('/subscribe/complete')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.user) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
  component: SubscribeCompleteRoute,
});

function SubscribeCompleteRoute() {
  return <SubscribeCompletePage />;
}
